import Request from "src/request";
import { environment } from "src/variables";
import { Box, ThemeProvider, createTheme, Typography, TextField } from "@material-ui/core";
import BookmarkIcon from "@material-ui/icons/Bookmark";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import { Observable } from "rxjs";

// Components
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "src/app/components/Header";
import File from "src/app/components/File";
import Signature from "src/app/components/Signature";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Styles
import { Wrapper, Spacer } from "src/app/App.styles";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const asset: any = {
  customer: null,
  errors: {},
  request: {
    url: "",
    token: "",
  },
};

const toastAll: any = toast;

const theme = createTheme({
  palette: {
    primary: {
      main: "#1ba0d7",
    },
    secondary: {
      main: "#a27c10",
    },
  },
});

const bannerText: any = {
  style: {
    fontFamily: "Georgia, serif",
    background: "linear-gradient(#1ba0d7, #a27c10)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "50px",
  },
};

export default function Dispatch() {
  const [searchParams] = useSearchParams();
  const [userId, setUserId] = useState(null);
  const [customer, setCustomer] = useState([]);
  const [loading, setLoading] = useState(true);
  const [disabledDeliveries, setDisabledDeliveries] = useState([]);

  useEffect(() => {
    const url = environment.apiPath + "/public/courier/dispatch?token=" + searchParams.get("token");
    Request(url, { method: "GET" }).subscribe(
      (result: any) => {
        const newDisabledDeliveries: any = [...disabledDeliveries];
        result.invoice.deliveries.forEach((delivery: any) => {
          if (!userId) setUserId(result.keyedDeliveries[delivery.id].user_id);
          newDisabledDeliveries[delivery.id] = result.keyedDeliveries[delivery.id].completed_at;
          if (newDisabledDeliveries[delivery.id]) return;
          newDisabledDeliveries[delivery.id] = !result.keyedDeliveries[delivery.id].started_at;
        });
        setDisabledDeliveries(newDisabledDeliveries);
        const customerData: any = new Array(result);
        setCustomer(customerData);
        setLoading(false);
      },
      (error: any) => {
        console.error("Error fetching data:", error.message);
        setLoading(false); // Handle error state if needed
      }
    );
  }, []);

  const sendNoteRequest = (url: string, requestMethod: string, body: any) => {
    return Observable.create((observer: any) => {
      Request(url, { method: requestMethod, body: JSON.stringify(body) }, "application/json").subscribe(
        (result: any) => {
          observer.next(result);
          observer.complete();
        },
        (error: any) => {
          console.error(error);
        }
      );
    });
  };

  const handleDelivery = (delivery: any) => {
    if (!delivery) return;

    const customerArray: any = customer;
    const customerData: any = customer[0];
    const payload: any = { delivery_id: delivery.id, invoice_id: customerData.invoice.id };
    const url = environment.apiPath + "/public/courier/update";
    Request(url, { method: "PATCH", body: JSON.stringify(payload) }, "application/json").subscribe(
      (result: any) => {
        const newDisabledDeliveries: any = [...disabledDeliveries];
        result.invoice.deliveries.forEach((delivery: any) => {
          newDisabledDeliveries[delivery.id] = result.invoice.keyedDeliveries[delivery.id].completed_at;
          if (newDisabledDeliveries[delivery.id]) return;
          newDisabledDeliveries[delivery.id] = !result.invoice.keyedDeliveries[delivery.id].started_at;
        });
        setDisabledDeliveries(newDisabledDeliveries);
      },
      (error: any) => {
        console.error("Error fetching data:", error.message);
      }
    );
  };

  const editNote = (index: number) => {
    const customerData: any = customer[0];
    const note = customerData.notes[index];
    note.edit = !note.edit;
    if (!note.edit) {
      const url = environment.apiPath + "/public/customer/note" + (isNaN(note.id) ? "" : "/" + note.id);
      const payload: any = {
        value: note.value,
        bookmarked: note.bookmarked,
        user_fk: userId,
      };
      if (isNaN(note.id)) payload.customer_id = customerData.id;
      sendNoteRequest(url, isNaN(note.id) ? "POST" : "PATCH", payload).subscribe((result: any) => {
        customerData.notes = result;
        const updateCustomer: any = new Array(customerData);
        setCustomer(updateCustomer);
      });
    } else {
      const updateCustomer: any = new Array(customerData);
      setCustomer(updateCustomer);
    }
  };

  const bookmarkNote = (index: number) => {
    const customerData: any = customer[0];
    customerData.notes[index].bookmarked = !customerData.notes[index].bookmarked;
    const updateCustomer: any = new Array(customerData);
    setCustomer(updateCustomer);
  };

  const setNewNote = () => {
    const customerData: any = customer[0];
    customerData.notes.unshift({ id: "new", bookmarked: 0, value: "", edit: true });
    const updateCustomer: any = new Array(customerData);
    setCustomer(updateCustomer);
  };

  const removeNewNote = () => {
    const customerData: any = customer[0];
    customerData.notes.shift();
    const updateCustomer: any = new Array(customerData);
    setCustomer(updateCustomer);
  };

  const deleteNote = (index: number) => {
    const customerData: any = customer[0];
    const note = customerData.notes[index];
    sendNoteRequest(environment.apiPath + "/public/customer/note/" + note.id, "PATCH", {
      deleted_at: true,
    }).subscribe((result: any) => {
      customerData.notes = result;
      const updateCustomer: any = new Array(customerData);
      setCustomer(updateCustomer);
    });
  };

  const fieldChanged = (event: any, index: number) => {
    const customerData: any = customer[0];
    const note = customerData.notes[index];
    note.value = event.target.value;
  };

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      dispatchContainer: {
        margin: "0 20px",
      },
      foreground: {
        minWidth: "100%",
        minHeight: "100%",
      },
      toast: {
        top: "50%!important",
        left: "50%!important",
        transform: "translate(-50%, -50%)!important",
        position: "fixed",
      },
      delivery: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      },
      deliveryButton: {
        border: "none",
        borderRadius: "4px",
        color: "white",
        padding: "8px 16px",
        margin: "4px 2px",
        backgroundColor: "#4CAF50",
      },
      noteRow: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        border: "1px solid #ccc",
        borderRadius: "4px",
      },
    })
  );
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
      <section key="dispatch-section" className={classes.foreground}>
        <Wrapper>
          <Header text={environment.siteTitle} style={bannerText.style} divider={true} />
        </Wrapper>
        <Spacer height={32} />
        <div className={classes.dispatchContainer}>
          {customer &&
            customer.map((item: any) => {
              if (loading) {
                return <div>Loading...</div>;
              } else {
                return customer ? (
                  <div key={item.id}>
                    <Typography variant="h6" component="div">
                      Customer: {item.first_name + " " + item.last_name}
                    </Typography>
                    <Typography variant="h6" component="div">
                      Phone#: <a href={"tel:+1" + item.phone}>{item.phone}</a>
                    </Typography>
                    <Typography variant="h6" component="div">
                      Email: <a href={"mailto:" + item.email}>{item.email}</a>
                    </Typography>
                    <Spacer height={6} />
                    <File
                      id={item.id}
                      type="id"
                      image={item.image && item.image.id ? item.image.id : null}
                      urlRequest="/public/courier/upload-image"
                    />
                    <Spacer height={12} />
                    <Signature
                      id={item.id}
                      type="signature"
                      image={item.image && item.image.signature ? item.image.signature : null}
                      urlRequest="/public/courier/upload-image"
                      width="400"
                      height="200"
                    />
                    {item.invoice ? (
                      <div key={item.invoice.id}>
                        <Spacer height={32} />
                        <Typography variant="h6" component="div">
                          Invoice #{item.invoice.number}
                          <br />
                          Please complete the following pickups then the drop-offs.
                        </Typography>
                        {item.invoice.deliveries.map((delivery: any) => {
                          return (
                            <span key={delivery.id} className={classes.delivery}>
                              {delivery.drop === 0 ? "Pickup address: " : "Drop off address: "}
                              <a
                                href={
                                  "https://google.com/maps?q=" +
                                  encodeURI(
                                    delivery.line_1 + "," + delivery.city + "," + delivery.state + "," + delivery.zip
                                  )
                                }
                              >
                                {delivery.line_1 + " " + delivery.city + ", " + delivery.state + " " + delivery.zip}
                              </a>
                              <button
                                id={delivery.id}
                                className={classes.deliveryButton}
                                disabled={disabledDeliveries[delivery.id]}
                                onChange={(e: any) => (e.disabled = true)}
                                onClick={() => handleDelivery(item.keyedDeliveries[delivery.id])}
                              >
                                Done
                              </button>
                            </span>
                          );
                        })}
                        <Typography variant="h6" component="div" className={classes.delivery}>
                          <span>Total:</span>
                          <span>${item.invoice.total.toFixed(2)}</span>
                        </Typography>
                        <div id="noteHeader" className={classes.delivery}>
                          <h4>Notes</h4>{" "}
                          <div>
                            <button type="button" onClick={() => setNewNote()}>
                              Add
                            </button>
                          </div>
                        </div>
                        {item.notes.map((note: any, index: number) => {
                          return (
                            <span>
                              <Box component="form" className={classes.noteRow}>
                                <button
                                  type="button"
                                  disabled={!note.edit}
                                  style={{ alignSelf: "flex-end", backgroundColor: "transparent" }}
                                  onClick={() => bookmarkNote(index)}
                                >
                                  {note.bookmarked ? (
                                    <BookmarkIcon
                                      style={{
                                        color: theme.palette.secondary.main,
                                      }}
                                    />
                                  ) : (
                                    <BookmarkBorderIcon
                                      style={{
                                        color: note.edit ? theme.palette.secondary.main : "transparent",
                                      }}
                                    />
                                  )}
                                </button>
                                <TextField
                                  key={note.id}
                                  multiline
                                  maxRows={4}
                                  disabled={!note.edit}
                                  defaultValue={note.value}
                                  onChange={(e: any) => fieldChanged(e, index)}
                                  variant="standard"
                                />
                                <div className={classes.delivery}>
                                  <button
                                    type="button"
                                    style={{ visibility: note.edit ? "visible" : "hidden" }}
                                    onClick={() => (isNaN(note.id) ? removeNewNote() : deleteNote(index))}
                                  >
                                    {isNaN(note.id) ? "Discard" : "Delete"}
                                  </button>
                                  <button type="button" onClick={() => editNote(index)}>
                                    {note.edit ? "Save" : "Edit"}
                                  </button>
                                </div>
                              </Box>
                              <Spacer height={12} />
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                ) : null;
              }
            })}
        </div>
        <ToastContainer className={classes.toast} />
      </section>
    </ThemeProvider>
  );
}
